export default __webpack_public_path__ + "static/media/logo.eadf4dab.svg";